const { REACT_APP_API_URL } = process.env;

const getQrCardImage = (code: string) => {
  return `${REACT_APP_API_URL}/qrImage/${code}`;
};

export default getQrCardImage;
